module.exports = __webpack_public_path__ + "img/typing.78bbe0df.gif";